export default __webpack_public_path__ + "static/media/postman-example.bfd534e2.png";